import { initializeApp } from 'firebase/app';
import { getAuth } from "firebase/auth";
const firebaseConfig = {
    apiKey: "AIzaSyAD7ayuLONsXkpRpkuOB1mOFRwVdbeFCOM",
    authDomain: "kuf-loppis-beed7.firebaseapp.com",
    projectId: "kuf-loppis-beed7",
    storageBucket: "kuf-loppis-beed7.appspot.com",
    messagingSenderId: "426787755853",
    appId: "1:426787755853:web:1626a22125c0b94d23c904",
    databaseURL: "https://kuf-loppis-beed7-default-rtdb.europe-west1.firebasedatabase.app/",    
};
const app = initializeApp(firebaseConfig);
export const auth = getAuth()
export default app;